import { sessionLogout } from "./sessionAuth";
import { useLocation } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

export const logOut = () => {
    sessionLogout();
};

export const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

export const genOrderId = () => {
    const now = Date.now().toString();
    const randomNum = Math.floor(Math.random() * 100);
    return now + randomNum;
};

// code for anaytics
export const genAnalyticsURL = (url, stype, orderID) => {
    const [path, queryString] = url.split("?");
    // console.log('Utility func', path)
    if (stype && orderID) {
        return `${path}/${stype}/${orderID}`;
    } else if (stype) {
        return `${path}/${stype}`;
    } else if (orderID) {
        return `${path}/${orderID}`;
    } else {
        return path;
    }
};

// Code for showing error messages using sweetalert

export const showToastMessage = ({ icon, mssge, time = 1000 }) => {
    const MySwal = withReactContent(Swal);

    MySwal.fire({
        toast: true,
        position: "bottom",
        icon: icon,
        title: mssge,
        showConfirmButton: false,
        timer: time,
    });
};

// Code to get timestamp from millisecods || AI Description Generator
const periods = {
    month: 30 * 24 * 60 * 60 * 1000,
    week: 7 * 24 * 60 * 60 * 1000,
    day: 24 * 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    minute: 60 * 1000,
    seconds: 1000,
};

export const formatTimeStamp = (timeCreated) => {
    var diff = Date.now() - new Date(timeCreated).getTime();

    if (diff > periods.month) {
        // it was at least a month ago
        return Math.floor(diff / periods.month) + " months ago";
    } else if (diff > periods.week) {
        return Math.floor(diff / periods.week) + " weeks ago";
    } else if (diff > periods.day) {
        return Math.floor(diff / periods.day) + " days ago";
    } else if (diff > periods.hour) {
        return Math.floor(diff / periods.hour) + " hrs ago";
    } else if (diff > periods.minute) {
        return Math.floor(diff / periods.minute) + " min ago";
    } else if (diff > periods.seconds) {
        return Math.floor(diff / periods.seconds) + " sec ago";
    }
    return "Just now";
};

export const ValidateEmail = (mail) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true;
    }
    // alert("You have entered an invalid email address!")
    return false;
};

export const filterParagraph = (paragraph) => {
    let para = paragraph;
    para = para.replace(/(\r\n|\r|\n){2,}/g, "$1\n");
};

export const scrollToTop = (top, left) => {
    window.scrollTo({
        top: top || 0,
        left: left || 0,
        behavior: "smooth",
    });
};


export const calculateExtraPrice = (numofImages, basePrice) => {
    const extraSetsPrice = (Math.ceil((numofImages - basePrice) / 5))*5;
    return extraSetsPrice
    //updatedPrice =  basePrice + extraSets;
};